<div class="dashboardNewContentContainer cx-one-ui height100" style="overflow: hidden;">
    <div class="workspaceDashboardsContainer height100" *ngIf="dashboardService.workspaceKey != null">
        <div *ngFor="let dashboard of dashboardService.dashboards" class="height100">
            <cv-responsive-dashboard  *ngIf="dashboard?.DashboardKey != null" [hidden]="!isActiveDashboard(dashboard)" class="responsiveDashboard" [iscxonedashboard]="true"
                                     [dashboardInfo]="dashboard"></cv-responsive-dashboard>
            <cv-cxone-empty-workspace *ngIf="dashboard?.DashboardKey == null || isActiveDashboard(dashboard) == null"></cv-cxone-empty-workspace>
        </div>
    </div>
</div>
